import { createFileRoute } from "@tanstack/react-router";

import ContactPage from "./-components/ContactPage";

export const Route = createFileRoute(
  "/_app/_dashboard/subscription/cancel/contact"
)({
  component: ContactPage,
});
